import { jsx as _jsx } from "react/jsx-runtime";
import { CommandLoading } from "@air/cmdk";
import { tailwindMerge } from "@air/tailwind-variants";
export const ComboboxLoading = (param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(CommandLoading, {
        className: tailwindMerge("p-2 text-center text-14 text-grey-11", className),
        "data-testid": "COMBOBOX_LOADING",
        ...restOfProps
    });
};
